// Vendor packages
import Vue from 'vue';
import VeeValidate from 'vee-validate';

// Exports from App
import App from './App';
import { Globals } from './mixins';
import { router } from './router';
import { store } from './store';

Vue.use(VeeValidate);
Vue.config.productionTip = false;

// Register global mixins
Vue.mixin({
	mixins: [Globals]
});

new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',

	components: {
		App,
	}
})



// WEBPACK FOOTER //
// ./src/main.js